import React from 'react'
import { Box, Card, Grid, Link, Typography } from '@mui/material';
import './LostCargoReturnDetail.scss';
import { useLostCargoReturnDetailPage } from '../context/LostCargoReturnDetailPageContext';
import TimeHelper from '../../../utils/time';
import { useTranslation } from 'react-i18next';
import CopyToClipboardButton from '../../../atomic/atoms/SCUICopyToClipboardButton/SCUICopyToClipboardButton';
import { LCRD } from '../lostCargoReturnDetailPage.classes';

function LostCargoInfoCard() {
    const { returnDetailData } = useLostCargoReturnDetailPage();
    const { t } = useTranslation();
    return (returnDetailData && (<Card className={LCRD.infoCard} sx={{ paddingTop: 3 }}>
        <Grid className={LCRD.infoCardGrid} container spacing={1}>
            <Grid
                size={{
                    xs: 12,
                    md: 6
                }}>
                {/* Sol Sütun Verileri - Müşteri Bilgileri */}
                <Box className={LCRD.infoRow} mb={1}>
                    <Box display="flex" alignItems="center">
                        <Typography className={LCRD.infoLabel} variant="subtitle2" color="text.secondary" sx={{ fontWeight: 'bold', mr: 2, minWidth: '120px' }}>
                            {t("lostCargoReturnPageBuilder.returnId")}:
                        </Typography>
                        <Typography className={LCRD.infoValue}>
                            {returnDetailData.returnId}
                        </Typography>
                    </Box>
                </Box>
                <Box className={LCRD.infoRow} mb={1}>
                    <Box display="flex" alignItems="center">
                        <Typography className={LCRD.infoLabel} variant="subtitle2" color="text.secondary" sx={{ fontWeight: 'bold', mr: 2, minWidth: '120px' }}>
                            {t("lostCargoReturnPageBuilder.rmaCode")}:
                        </Typography>
                        <Typography className={LCRD.infoValue}>
                                {returnDetailData.rmaCode}
                        </Typography>
                    </Box>
                </Box>
                {returnDetailData.customerId !== null && returnDetailData.customerId !== undefined  && returnDetailData.customerId != 0 &&
                <Box className={LCRD.infoRow} mb={1}>
                    <Box display="flex" alignItems="center">
                        <Typography className={LCRD.infoLabel} variant="subtitle2" color="text.secondary" sx={{ fontWeight: 'bold', mr: 2, minWidth: '120px' }}>
                            {t("lostCargoReturnPageBuilder.customerId")}:
                        </Typography>
                        <Typography className={LCRD.infoValue}>
                            <Link
                                className={LCRD.linkCustomerManagement}
                                href={`/customerManagement?ActiveTab=OrderInformation&customerId=${returnDetailData.customerId}`}
                                underline="hover"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {returnDetailData.customerId}
                            </Link>
                        </Typography>
                    </Box>
                </Box>
                }
                
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    md: 6
                }}>
                {/* Sağ Sütun Verileri - İade Bilgileri */}
                

                <Box className={LCRD.infoRow} mb={1}>
                    <Box display="flex" alignItems="center">
                        <Typography className={LCRD.infoLabel} variant="subtitle2" color="text.secondary" sx={{ fontWeight: 'bold', mr: 2, minWidth: '120px' }}>
                            {t("lostCargoReturnPageBuilder.orderDate")}:
                        </Typography>
                        <Typography className={LCRD.infoValue}>
                            {TimeHelper.formatDateHour(returnDetailData.orderDate)}
                        </Typography>
                    </Box>
                </Box>

                <Box className={LCRD.infoRow} mb={1}>
                    <Box display="flex" alignItems="center">
                        <Typography className={LCRD.infoLabel} variant="subtitle2" color="text.secondary" sx={{ fontWeight: 'bold', mr: 2, minWidth: '120px' }}>
                            {t("lostCargoReturnPageBuilder.shippingListNo")}:
                        </Typography>
                        <Typography className={LCRD.infoValue} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Link
                                className={LCRD.linkShippingList}
                                href={`/orderdetail?shippingListNo=${returnDetailData.shippingListNo}`}
                                underline="hover"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {returnDetailData.shippingListNo}
                            </Link>
                            <CopyToClipboardButton textToCopy={returnDetailData.shippingListNo} sx={{ ml: 1 }} />
                        </Typography>
                    </Box>
                </Box>

                <Box className={LCRD.infoRow} mb={1}>
                    <Box display="flex" alignItems="center">
                        <Typography className={LCRD.infoLabel} variant="subtitle2" color="text.secondary" sx={{ fontWeight: 'bold', mr: 2, minWidth: '120px' }}>
                            {t("lostCargoReturnPageBuilder.orderId")}:
                        </Typography>
                        <Typography className={LCRD.infoValue}>
                            <Link
                                className={LCRD.linkOrderDetail}
                                href={`/orderdetail?orderId=${returnDetailData.orderId}`}
                                underline="hover"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {returnDetailData.orderId}
                            </Link>
                        </Typography>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    </Card>));
}

export default LostCargoInfoCard